<template>
  <div class="DAV-workshop__trunk">
    <component-title color="green" @goPrev="goPrev" />
    <div class="DAV-blockClass">
      <div class="icon-wrap">
        <div class="DAV-titleBar">
          <h4>아이콘 라이브러리</h4>
        </div>
        <ul class="icon-list">
          <li
            v-for="icon in getPopup.value.iconFiles"
            :key="icon.id"
            :class="{active: icon.id === getPopup.value.seleceId}"
            @click="updateIcon(icon.id)"
          >
            <span></span>
            <div
              class="mask-icon"
              :style="{
                'background-color': getPopup.value.color,
                '-webkit-mask-image': `url(${icon.url})`
              }"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
const ModuleEditor = createNamespacedHelpers("ModuleEditor");

export default {
  data() {
    return {};
  },
  computed: {
    ...ModuleEditor.mapGetters(["getPopup"])
  },
  mounted() {
    console.log(this.getPopup.value);
  },
  methods: {
    // 이전 리스트로 이동
    goPrev() {
      this.$store.commit("ModuleEditor/setPopup", {
        page: null
      });
    },
    // updateIcon
    updateIcon(id) {
      this.$EventBus.$emit(`UpdateIcon${this.getPopup.option.id}`, id);
      this.getPopup.value.seleceId = id;
    }
  },
  components: {
    ComponentTitle: () => import("@/components/editor/ComponentTitle.vue")
  }
};
</script>

<style lang="scss" scoped>
.icon-wrap {
  background: #fff;
  padding: 4px 16px 24px;

  .icon-list {
    display: flex;
    flex-wrap: wrap;

    li {
      position: relative;
      width: 83px;
      height: 83px;
      background: #f4f7ff;
      border: 1px solid #d8dae5;
      border-radius: 8px;
      margin-top: 16px;
      margin-right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .mask-icon {
        width: 36px;
        height: 36px;
        -webkit-mask-size: 36px 36px;
      }

      @media screen and (min-width: 1024px) {
        &:nth-child(4n + 0) {
          margin-right: 0px;
        }
      }
    }

    .active {
      background: #d2f8ec;
      border: 1px solid #54c7a2;

      span {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 16px;
        height: 16px;
        background-image: url($path + "ico_check.svg");
        background-repeat: no-repeat;
        background-position: 50% 50%;
      }
    }
  }
}

/* 반응형 - desktop */
@media screen and (min-width: 1024px) {
  .DAV-workshop__heading {
    h3 {
      padding-left: 32px;
    }
  }
}
/* 반응형 - mobile */
@media screen and (max-width: 1023px) {
  .DAV-workshop__heading {
    display: none !important;
  }
}
</style>
